import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-jquidate-picker',
	templateUrl:'./JQUIDatePickerPage.html',
	styles: [],
	styleUrls:['./JQUIDatePickerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDatePickerPage
{
	mdContent_191 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.datepicker.JQUIDatePicker;
\`\`\``;
	mdContent_192 = `\`\`\`java
new JQUIDatePicker&lt;&gt;()
\`\`\``;
	mdContent_193 = `\`\`\`java
new JQUIDatePicker&lt;&gt;(Date selectedDate)
\`\`\``;
	mdContent_194 = `\`\`\`java
var dp = new JQUIDatePicker<>();
dp.getOptions().setDateFormat("yy-mm-dd");
dp.getOptions().setChangeMonth(true);
dp.getOptions().setChangeYear(true);
\`\`\``;
}
